import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { auth } from '../../firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';

import * as routes from '../../constants/routes';
import { Grid } from 'semantic-ui-react';
import { API } from '../../constants/api';

class SignInPage extends Component {
  render() {
    if (!!auth && auth.currentUser) {
      this.props.history.push(routes.ACCOUNT);
      return <div />;
    }

    return (
      <div>
        <SignInForm
          invitation={this.props.invitation}
          embedded={this.props.embedded}
          history={this.props.history}
          productName={this.props.productName}
        />
      </div>
    );
  }
}

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  url: '',
  email: '',
  password: '',
  error: null,
  formValid: false,
  activeStep: 'user',
};

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    if (!!auth && auth.currentUser) {
      this.props.history.push(routes.ACCOUNT);
    }
    if (
      this.props.invitation !== undefined &&
      this.props.invitation.team !== undefined
    ) {
      this.setState({
        url: this.props.invitation.team.url,
        activeStep: 'user',
      });
    }

    if (!!auth && !auth.currentUser && this.props.embedded) {
      this.setState({
        email: 'shopembed@yourdocket.com',
        password: 'shopembed1234',
      });

      setTimeout(() => {
        this.signIn();
      }, 50);
    }
  }

  signIn() {
    const { email, password } = this.state;

    const { history, embedded } = this.props;
    signInWithEmailAndPassword(auth, email, password)
      .then(data => {
        if (
          this.props.invitation !== undefined &&
          this.props.invitation.id !== undefined
        ) {
          API.get(
            `/httpConfirmInvitation?userId=${data.user.uid}&inviteId=${
              this.props.invitation.id
            }`,
          ).then(response => {
            if (response.data.confirmed) {
              this.setState(() => ({ ...INITIAL_STATE }));
              history.push(routes.ACCOUNT);
            }
            this.setState(updateByPropertyName('error', 'Error signing in'));
          });
        }

        if (embedded) {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
      });

    // event.preventDefault();
  }

  validateURL() {
    let url = this.refs.url.value;
    let valid = false;
    if (url !== undefined && url !== null && url !== '') {
      valid = true;
    }
    this.setState({ formValid: valid });
  }

  URLSubmit() {
    let url = this.refs.url.value;
    this.setActiveStep('user');
  }

  setActiveStep(step) {
    this.setState({ activeStep: step });
  }

  getURLValue() {
    if (
      this.refs.url == undefined ||
      this.refs.url.value == undefined ||
      this.refs.url.value == ''
    ) {
      if (typeof this.props.invitation.team !== 'undefined') {
        return this.props.invitation.team.url;
      }
    } else {
      return this.refs.url.value;
    }
  }

  onSubmit = event => {
    this.signIn();
    event.preventDefault();
  };

  render() {
    const { email, password, error } = this.state;

    const { embedded } = this.props;

    let content = undefined;
    if (this.state.activeStep === 'user') {
      content = (
        <Grid
          stackable
          style={{
            marginTop: 0,
            marginBottom: 0,
            background: 'white',
            borderRadius: 10,
            padding: '50px 20px',
            maxWidth: 800,
            boxShadow: '0px 3px 15px rgba(0,0,0,0.1)',
          }}
        >
          <Grid.Row
            centered
            style={{
              paddingTop: '0em',
              paddingBottom: '0em',
              margin: '0em 1em 0em 1em',
            }}
          >
            <div
              style={{
                marginTop: '1em',
                fontFamily: 'Inter',
                lineHeight: 1.25,
                fontSize: 36,
                fontWeight: '300',
                paddingBottom: '0.75em',
              }}
            >
              <div style={{ paddingBottom: '.5em', fontWeight: 'bold' }}>
                {`Sign in to your ${this.props.productName} Account`}
              </div>
              <div
                style={{
                  marginTop: '0em',
                  fontFamily: 'Inter',
                  fontSize: 18,
                  color: '#444',
                  fontWeight: '300',
                }}
              >
                Enter your credentials so we can get you connected with your
                team.
              </div>
            </div>
          </Grid.Row>
          {error ? (
            <Grid.Row style={{ marginTop: '0em', paddingBottom: '0em' }}>
              <div className="ui centered cards" style={{ width: '100%' }}>
                <div
                  className="ui card"
                  style={{ width: '35em', boxShadow: 'none' }}
                >
                  <div className="content">
                    <div className="ui icon warning message">
                      <i className="lock icon" />
                      <div className="content">
                        <div className="header">Sign In failed!</div>
                        {error && <p>{error.message}</p>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid.Row>
          ) : (
            undefined
          )}
          <Grid.Row style={{ marginTop: '0em', paddingBottom: '0em' }}>
            <div className="ui centered cards" style={{ width: '100%' }}>
              <div
                className="ui card"
                style={{ width: '35em', boxShadow: 'none' }}
              >
                <div className="content">
                  <form
                    className="ui form"
                    onSubmit={this.onSubmit}
                    style={{ fontSize: 18 }}
                  >
                    <div className="field">
                      <label>Email</label>
                      <input
                        name="email"
                        value={email}
                        onChange={event =>
                          this.setState(
                            updateByPropertyName('email', event.target.value),
                          )
                        }
                        type="text"
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="field">
                      <label>Password</label>
                      <input
                        value={password}
                        onChange={event =>
                          this.setState(
                            updateByPropertyName(
                              'password',
                              event.target.value,
                            ),
                          )
                        }
                        type="password"
                        placeholder="Password"
                      />
                    </div>
                    <button
                      className="ui fluid primary button"
                      type="submit"
                      style={{ marginTop: '2em', fontSize: 18 }}
                      onClick={() => {
                        this.signIn();
                      }}
                    >
                      Sign In
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </Grid.Row>
        </Grid>
      );
    }

    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 100,
        }}
      >
        {!embedded && content}
      </div>
    );
  }
}

export { SignInForm };

function mapStateToProps(state) {
  return {
    invitation: state.app.invitation,
    productName: state.app.productName,
    embedded: state.app.embedded,
    state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  withRouter,
)(SignInPage);
